import request from '@/utils/request'

// 查询周边商品列表
export function listPeriphery(query) {
  return request({
    url: '/system/goodsPeriphery/list',
    method: 'get',
    params: query,
  })
}

// 查询周边商品详细
export function getPeriphery(id) {
  return request({
    url: '/system/goodsPeriphery/' + id,
    method: 'get',
  })
}

// 新增周边商品
export function addPeriphery(data) {
  return request({
    url: '/system/goodsPeriphery',
    method: 'post',
    data: data,
  })
}

// 修改周边商品
export function updatePeriphery(data) {
  return request({
    url: '/system/goodsPeriphery',
    method: 'put',
    data: data,
  })
}

// 删除周边商品
export function delPeriphery(id) {
  return request({
    url: '/system/goodsPeriphery/' + id,
    method: 'delete',
  })
}

// 查询周边订单列表
export function listOrderPeriphery(query) {
  return request({
    url: '/system/orderPeriphery/list',
    method: 'get',
    params: query,
  })
}

// 新增周边订单
export function addOrderPeriphery(data) {
  return request({
    url: '/system/orderPeriphery',
    method: 'post',
    data: data,
  })
}

// 修改周边订单
export function updateOrderPeriphery(data) {
  return request({
    url: '/system/orderPeriphery',
    method: 'put',
    data: data,
  })
}

// 删除周边订单
export function delOrderPeriphery(id) {
  return request({
    url: '/system/orderPeriphery/' + id,
    method: 'delete',
  })
}

// 查询周边订单评价列表
export function listComment(query) {
  return request({
    url: '/system/peripheryComment/list',
    method: 'get',
    params: query,
  })
}

// 查询周边订单评价详细
export function getComment(id) {
  return request({
    url: '/system/peripheryComment/' + id,
    method: 'get',
  })
}

// 新增周边订单评价
export function addComment(data) {
  return request({
    url: '/system/peripheryComment',
    method: 'post',
    data: data,
  })
}

// 修改周边订单评价
export function updateComment(data) {
  return request({
    url: '/system/peripheryComment',
    method: 'put',
    data: data,
  })
}

// 删除周边订单评价
export function delComment(id) {
  return request({
    url: '/system/peripheryComment/' + id,
    method: 'delete',
  })
}

// 查询类目列表
export function listTableCategory(data) {
  return request({
    url: '/sysGoodsCategory/list',
    method: 'post',
    data,
  })
}

// 新增类目
export function addTable(data) {
  return request({
    url: '/sysGoodsCategory/add',
    method: 'post',
    data: data,
  })
}

// 修改类目
export function updateTable(data) {
  return request({
    url: '/sysGoodsCategory/upd',
    method: 'post',
    data: data,
  })
}

// 删除类目
export function delTable(id) {
  return request({
    url: `/sysGoodsCategory/delete/?id=${data}`,
    method: 'get',
  })
}
